exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-list-item{display:block;padding:0}adp-list-item h5{margin-bottom:5px;color:#000;font-size:14px;font-family:ProximaNova-Semibold,Arial,Helvetica,sans-serif}adp-list-item .subtitle{color:#000;font-size:12px;font-family:ProximaNova-Regular,Arial,Helvetica,sans-serif;opacity:.5}adp-list-item .subtitle .bold{font-family:ProximaNova-Bold,Arial,Helvetica,sans-serif}adp-list-item .ico-wrap{display:block;height:100%;position:relative;padding:5px;width:40px;height:40px}adp-list-item .ico-wrap i.warning{color:#d0011b;position:relative;font-size:27px;top:50%;left:50%;transform:translateY(-50%) translateX(-50%)}adp-list-item .ico-wrap .count{position:absolute;right:0;bottom:0;display:flex;align-items:center;justify-content:center;width:20px;height:20px;text-align:center;font-size:10px;line-height:20px;border-radius:50%;background-color:#d0011b;border:2px solid #fff;color:#fff}adp-list-item .ico-wrap span.ico-circle-down{color:#417505!important;position:relative;font-size:23px;padding:3px;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpListItem/adpListItem.less
// module id = 498
// module chunks = 0